import {episode} from './types';

export function isEpisode(ep: episode | string): ep is episode {
    return ep !== null && ep !== undefined && (ep as episode).id !== undefined;
}